// extracted by mini-css-extract-plugin
module.exports = {"container":"algolia-banner_container__3Hldl","link":"algolia-banner_link__XEEXj","image":"algolia-banner_image__Ylwkb"};